import { atomWithStorage } from '@capsicum/common';

export const worldChampionshipTutorialAtom = atomWithStorage<boolean>('worldChampionshipTutorial', false);
